module.exports = __webpack_public_path__ + "static/media/13ITC4.445c65c2.jpg";